/* ----------------- Components --------------- */
import Box from "@memorang/ui/src/components/Box";
import EmptyView from "@memorang/ui/src/components/EmptyView";
import SavedArticlesView from "../components/SavedArticlesView";
/* ----------------- Hooks --------------- */
import { useArticles } from "../hooks/useArticles";
const SavedArticlesContainer = ({
	isBrowseTab,
	searchQuery,
}: {
	isBrowseTab?: boolean;
	searchQuery?: string;
}) => {
	const {
		selectedArticleIds,
		handleSelectArticle,
		handleNavigateToArticle,
		savedArticles,
	} = useArticles();

	const finalSavedArticles =
		!isBrowseTab && searchQuery
			? savedArticles.filter((article) =>
					article.title.toLowerCase().includes(searchQuery.toLowerCase()),
				)
			: savedArticles;

	if (!finalSavedArticles.length) {
		return (
			<Box flexGrow={1} height="100%">
				<EmptyView
					title="No results found"
					subtitle="Try changing the search query"
				/>
			</Box>
		);
	}

	return (
		<SavedArticlesView
			savedArticles={finalSavedArticles}
			handleSelectArticle={handleSelectArticle}
			selectedArticleIds={selectedArticleIds}
			handleNavigateToArticle={handleNavigateToArticle}
		/>
	);
};

export default SavedArticlesContainer;
